import React from "react";
import { GenerateProposalPage } from "./pages/GenerateProposalPage";

export function App() {
  return <GenerateProposalPage />;
}

